import {translations} from 'presentation/translations-new';
import {CreatePeriodsConfigParams} from './types';
import {ShiftTypeEnum} from 'presentation/modules/booking/exam/constants/shiftTypeEnum';

const {afternoon, morning, night} = translations['pt-br'].privateFlow.bookingFlow.professionalFlow;
const {all, period} = translations['pt-br'].commons;

export const createPeriodsConfig = ({shiftSelected, onShiftChange}: CreatePeriodsConfigParams) => ({
	categoryTitle: period,
	categoryItemsList: [
		{
			active: shiftSelected === ShiftTypeEnum.ALL,
			title: all,
			onClick: () => onShiftChange(ShiftTypeEnum.ALL),
		},
		{
			active: shiftSelected === ShiftTypeEnum.MORNING,
			title: morning,
			onClick: () => onShiftChange(ShiftTypeEnum.MORNING),
		},
		{
			active: shiftSelected === ShiftTypeEnum.AFTERNOON,
			title: afternoon,
			onClick: () => onShiftChange(ShiftTypeEnum.AFTERNOON),
		},
		{
			active: shiftSelected === ShiftTypeEnum.NIGHT,
			title: night,
			onClick: () => onShiftChange(ShiftTypeEnum.NIGHT),
		},
	],
});
